import React from "react";
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import InfoIcon from 'SVGS/InfoIcon';
import { Tooltip } from 'react-tooltip';

// onChange={onChange} name="isSelfPay" checked={model.isSelfPay} label={"Self Pay"}
const CustomToggle = ({
  onChange,
  name,
  checked,
  label,
  disabled,
  toolTip,
  tooltipWidth = 220,
  Icon,
  iconClass,
  ...props
}) => {
  const IconComponent = Icon || InfoIcon;

  return (
    <div
      className={`flex items-center ${
        disabled ? "pointer-events-none opacity-60" : ""
      }`}
    >
      <div
        onClick={() =>
          onChange({
            target: {
              name,
              type: "checkbox",
              checked,
            },
          })
        }
        name={name}
        className={`${
          !checked || disabled ? "bg-gray-200" : "bg-primary"
        } min-w-[25px] shadow-sm cursor-pointer rounded-full relative flex items-center p-1 min-h-[14px]`}
      >
        <span
          className={`${
            !checked || disabled
              ? "bg-gray-400 right-[50%] "
              : "bg-white right-[3px]"
          } min-w-[11px] rounded-full min-h-[11px] transition-all duration-300 ease-in-out inline-block absolute top-1/2 -translate-y-1/2`}
        ></span>
      </div>
      {label && (
        <label className={`font-medium ml-2 mb-0`}>
          {label}
          {toolTip && (
            <>
              <IconComponent 
                className={`inline ${iconClass || ""}`} 
                size={14} 
                data-tooltip-id={`${name}-tooltip`} 
                data-tooltip-content={toolTip}
                style={{ marginLeft: '4px' }}
              />
              <Tooltip id={`${name}-tooltip`} style={{ zIndex: 2, maxWidth: tooltipWidth }} />
            </>
          )}
        </label>
      )}
    </div>
  );
};

export default withFeatureSafe(CustomToggle);